"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
let SnapScreenshotOptions = class SnapScreenshotOptions {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], SnapScreenshotOptions.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], SnapScreenshotOptions.prototype, "overlayHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], SnapScreenshotOptions.prototype, "includedHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", String)
], SnapScreenshotOptions.prototype, "headHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], SnapScreenshotOptions.prototype, "deviceScaleFactor", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], SnapScreenshotOptions.prototype, "hasTouch", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], SnapScreenshotOptions.prototype, "width", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], SnapScreenshotOptions.prototype, "height", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], SnapScreenshotOptions.prototype, "isLandscape", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], SnapScreenshotOptions.prototype, "isMobile", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    tslib_1.__metadata("design:type", Boolean)
], SnapScreenshotOptions.prototype, "isPartial", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], SnapScreenshotOptions.prototype, "renderTimeout", void 0);
SnapScreenshotOptions = tslib_1.__decorate([
    type_graphql_1.InputType()
], SnapScreenshotOptions);
exports.SnapScreenshotOptions = SnapScreenshotOptions;
//# sourceMappingURL=index.js.map